import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material'
import { AngularGoogleMapsComponent } from './angular-google-maps.component'
import { AngularGoogleMapsGeocoder } from './service/angular-google-maps-geocoder.service'
import { GoogleMapsFactory } from './service/google-maps-factory.service'
import { GoogleMapsLoader } from './service/google-maps-loader.service'
import { IconRegistry } from './service/icon-registry/icon-registry'

@NgModule({
    declarations: [
        AngularGoogleMapsComponent
    ],
    imports: [
        FormsModule,
        MatIconModule
    ],
    exports: [
        AngularGoogleMapsComponent
    ],
    providers: [
        AngularGoogleMapsGeocoder,
        GoogleMapsLoader,
        GoogleMapsFactory,
        IconRegistry
    ]
})
export class AngularGoogleMapsModule {
}
